
export default {
	list: 'InvestmentValuation',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentId: {
			class: "lookup",
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			hidden: false,
			readOnly:false
		},
		InvestmentInvestmentID: {
			class: "lookup",
			dataName: 'Investment/InvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 100,
			hidden: false,
			readOnly: true
		},
		InvestmentTitle: {
			class: "lookup",
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment',
			width: 100,
			hidden: false,
			readOnly: true
		},
		TaxYear: {
			class: "choice",
			dataName: 'TaxYear',
			type: 'string',
			title: 'Tax Year',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxQuarter: {
			class: "choice",
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quarter',
			width: 100,
			hidden: true,
			readOnly:false
		},
		TaxYearQuarter: {
			class: "value",
			dataName: 'TaxYearQuarter',
			type: 'string',
			title: 'Tax Period',
			width: 100,
			hidden: false,
			readOnly:true
		},
		ProjectedValue: {
			class: "value",
			dataName: 'ProjectedValue',
			type: 'number',
			title: 'Projected Value',
			width: 100,
			hidden: false,
			readOnly: false
		},
		CurrentValue: {
			class: "value",
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Value',
			width: 100,
			hidden: false,
			readOnly: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: false,
			readOnly:false
		}
	},
}